import { Typography, TypographyVariant } from '@eventbrite/marmalade';
import React from 'react';

import styles from './HeaderCTA.module.scss';

export interface HeaderCTAProps {
  /**
   * Display text for the CTA button
   */
  ctaBtnText: string;
  /**
   * CTA Url Link
   */
  ctaUrl: string;
  /**
   * Custom Style Class
   */
  className?: string;
  /**
   * Custom Variant
   */
  variant?: TypographyVariant;
}

export const HeaderCTA: React.FunctionComponent<HeaderCTAProps> = ({
  ctaBtnText,
  ctaUrl,
  className = '',
  variant,
}) => {
  return (
    <a href={ctaUrl} className={className}>
      <div className={`${styles.btn_cta} flex-center`}>
        <Typography as="p" align="center" color="neutral-800" variant={variant}>
          {ctaBtnText}
        </Typography>
      </div>
    </a>
  );
};
